"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The search input.
 */
var SelectInput = function SelectInput(_ref) {
  var title = _ref.title,
      value = _ref.value,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown;
  return _react2.default.createElement(
    "div",
    { className: "sb-select__inputContainer" },
    _react2.default.createElement(
      "span",
      { className: "sb-select__inputLabel" },
      title
    ),
    _react2.default.createElement("input", {
      className: "sb-select__input",
      type: "text",
      maxLength: "30",
      placeholder: "Search...",
      value: value,
      onChange: onChange,
      onKeyDown: onKeyDown
    })
  );
};

SelectInput.propTypes = {
  /**
   * Title to be displayed on mobile devices
   */
  title: _react.PropTypes.string.isRequired,
  /**
   * This is the controlled component, so it requires it's value.
   */
  value: _react.PropTypes.string.isRequired,
  /**
   * This is the controlled component, so it requires 'change' event handler.
   */
  onChange: _react.PropTypes.func.isRequired,
  /**
   * The 'keydown' event handler. It is used to handle 'Esc' and 'Enter' buttons.
   */
  onKeyDown: _react.PropTypes.func.isRequired
};

exports.default = SelectInput;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-select/lib/js/components/SelectInput.js
// module id = 2273
// module chunks = 0